import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, LEGAL_NAV, SITE } from "@/config/site";
import { SERVICES } from "@/data/services";

export const Footer = ({ onManageCookies }) => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-slate text-white grain" data-testid="site-footer">
      <div className="container-x pt-20 pb-10 relative z-10">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo light />
            <p className="mt-6 text-white/70 leading-relaxed max-w-sm">
              {SITE.baseline}. Maçonnerie, étanchéité, isolation, équipements techniques : un interlocuteur unique, du diagnostic à la finition.
            </p>
            <p className="mt-6 inline-flex items-center gap-2 text-xs font-semibold tracking-[0.18em] uppercase text-copper border border-copper/40 rounded-full px-4 py-2">
              Artisan inscrit au Répertoire des Métiers
            </p>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading uppercase text-lg font-bold tracking-wider text-white/90 mb-5">Navigation</h3>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}><Link to={n.to} className="text-white/70 hover:text-copper transition-colors" data-testid={`footer-link-${n.to === "/" ? "accueil" : n.to.slice(1)}`}>{n.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading uppercase text-lg font-bold tracking-wider text-white/90 mb-5">Prestations</h3>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}><Link to={`/services#${s.slug}`} className="text-white/70 hover:text-copper transition-colors">{s.title}</Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading uppercase text-lg font-bold tracking-wider text-white/90 mb-5">Contact</h3>
            <ul className="space-y-4 text-white/70">
              <li className="flex gap-3"><MapPin size={18} className="text-copper shrink-0 mt-0.5" /><address className="not-italic" data-testid="footer-address">{SITE.address.street}<br />{SITE.address.postalCode} {SITE.address.city}, {SITE.address.country}</address></li>
              <li className="flex gap-3"><Phone size={18} className="text-copper shrink-0 mt-0.5" /><a href={SITE.phone.href} className="hover:text-copper transition-colors" data-testid="footer-phone-link">{SITE.phone.display}</a></li>
              <li className="flex gap-3"><Mail size={18} className="text-copper shrink-0 mt-0.5" /><a href={`mailto:${SITE.email}`} className="hover:text-copper transition-colors" data-testid="footer-email-link">{SITE.email}</a></li>
              <li className="flex gap-3"><Clock size={18} className="text-copper shrink-0 mt-0.5" /><span>Lun – Ven : 8h00 – 18h00<br />Sam : 9h00 – 12h00 sur RDV</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between text-sm text-white/55">
          <div className="space-y-1">
            <p data-testid="footer-legal-line">© {year} {SITE.name} — {SITE.legalFormShort} au capital de {SITE.capital} — RCS {SITE.rcsCity} {SITE.siren}</p>
            <p>Siège social : {SITE.address.full} · Site hébergé par Namecheap</p>
          </div>
          <ul className="flex flex-wrap gap-x-5 gap-y-2">
            {LEGAL_NAV.map((l) => (
              <li key={l.to}><Link to={l.to} className="hover:text-copper transition-colors" data-testid={`footer-legal-${l.to.slice(1)}`}>{l.label}</Link></li>
            ))}
            <li><button onClick={onManageCookies} className="hover:text-copper transition-colors" data-testid="footer-manage-cookies">Gérer mes cookies</button></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};
